export const backs = [

    // 幼兒數學

    { from: '分類', to: ['誰比較多', '加法', '數氣球', '認識數字']},
    { from: '誰比較多', to: ['分類', '減法', '湊十釣魚', '數氣球']},
    { from: '數氣球', to: ['加法影片', '加法', '減法', '湊十釣魚', '分類']},
    
    // 低年級數學
    
    { from: '加法影片', to: ['加法'] },
    { from: '湊十釣魚', to: ['加法', '減法', '認識十進位'] },
    { from: '加法', to: ['減法', '乘法A~D', '認識十進位', '百數表'] },
    { from: '減法影片', to: ['減法'] },
    { from: '減法', to: ['除法', '正負數', '認識十進位'] },
    { from: '百數表', to: ['乘法A~D', '因數與倍數', '倍數著色', '認識十進位'] },
    { from: '認識十進位', to: ['乘法', '除法', '分數到小數'] },
    { from: '倍數著色', to: ['因數與倍數'] },
    { from: '乘法A~D', to: ['乘法E~F', '除法', '倍數著色', '面積的估算'] },

    // 中年級數學

    { from: '乘法E~F', to: ['除法', '代數入門'] },
    { from: '除法', to: ['除法直式的意涵', '分數影片', '分數', '因數與倍數', '代數入門'] },
    { from: '除法直式的意涵', to: ['除法直式精熟', '餘量的處理'] },
    { from: '除法直式精熟', to: ['餘量的處理'] },
    { from: '餘量的處理', to: ['分數影片', '分數'] },
    { from: '分數影片', to: ['分數'] },
    { from: '分數', to: ['因數與倍數', '代數入門', '面積的估算', '分數到小數', '正負分數'] },
    { from: '時間的計算', to: ['代數入門'] },
    { from: '數線', to: ['不等式', '正負數', '代數入門', '直角座標'] },
    { from: '分數到小數', to: ['指數與科學記號'] },
    
    // 高年級數學
    
    { from: '面積的估算', to: ['面積的公式', '體積與容積'] },
    { from: '面積公式', to: ['體積與容積', '一元一次方程式'] },
    { from: '體積與容積', to: ['幾何代數_乘法公式'] },
    { from: '代數入門', to: ['一元一次方程式', '物理量與單位換算'] },
    { from: '物理量與單位換算', to: ['比與比值'] },
    { from: '四則運算總複習', to: ['正負數', '代數入門'] },

    // 國中數學

    { from: '正負數', to: ['正負分數', '一元一次方程式', '數線'] },
    { from: '一元一次方程式', to: ['不等式', '二元一次方程式', '一元二次方程式', '多項式'] },
    { from: '指數與科學記號', to: ['指數與對數', '實無限與微分'] },
    { from: '二元一次方程式', to: ['直角座標', '國中數學觀念精華'] },
    { from: '直角座標', to: ['函數圖形', '極座標'] },
    { from: '函數圖形', to: ['二次函數', '指數與對數'] },
    { from: '一元二次方程式', to: ['二次函數', '國中數學觀念精華'] },
    { from: '二次函式', to: ['多項式', '國中數學觀念精華'] },
    { from: '幾何代數_乘法公式', to: ['幾何證明', '勾股定理'] },
    { from: '勾股定理', to: ['幾何證明', '根式運算'] },
    { from: '根式運算', to: ['幾何證明', '國中數學觀念精華'] },
    { from: '幾何證明', to: ['全等形', '相似三角形', '尺規作圖'] },
    { from: '全等形', to: ['相似三角形', '圓與角', '尺規作圖'] },
    { from: '尺規作圖', to: ['相似三角形', '圓與角', '三角形的心'] },
    { from: '數列與級數', to: ['機率與統計'] },
    { from: '多項式', to: ['實無限與微分'] },
    { from: '圓與角', to: ['三角形的心', '相似三角形'] },
    { from: '相似三角形', to: ['三角形的心', '三角函數'] },
    { from: '國中數學觀念精華', to: ['指數與對數', '三角函數'] },

    // 高中職數學

    { from: '指數與對數', to: ['實無限與微分'] },
    { from: '極座標', to: ['三角函數', '實無限與微分', '實無限與積分'] },
    { from: '球體的體積', to: ['實無限與積分'] },
    { from: '三角函數', to: ['實無限與微分', '實無限與積分'] },

    // 大專數學

    { from: '實無限與微分', to: ['實無限與積分'] }
];
